<template>
    <v-container class="pa-5" fluid>
        <AddMaterialDialog
            ref="addMaterialDialog"
            :is-open="addMaterialDialog"
            :request="request"
            :material="material"
            :validations="$v"
            :action="action"
            :papers="papers"
            :materials="materials"
            @update-material-name="updateMaterialName"
            @on-close="closeMaterialDialog"
        />
        <ConfirmDialog
            :is-open="assignUserDialog"
            :request="request"
            :action-loading="actionLoading.assignUser"
            @on-confirm="assignCurrentUser"
            @on-abort="closeConfirmAssignUserDialog"
        >
            <template #title>
                Przypisanie zapotrzebowania #{{ request.id }}
            </template>
            <template #content>
                Czy na pewno chcesz przypisać zapotrzebowanie do siebie?
            </template>
            <template #confirmButton>
                Potwierdź
            </template>
        </ConfirmDialog>
        <page-title>{{ pageTitle }}</page-title>

        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    :disabled="requestLoading"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row tag="form">
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-tabs
                                    v-model="tabs"
                                    background-color="transparent"
                                    slider-color="blue"
                                >
                                    <v-tab>
                                        Dane
                                    </v-tab>
                                    <v-tab>
                                        Załączniki
                                    </v-tab>
                                    <v-tab v-if="actionName === 'updateRequest'">
                                        Zapytania
                                    </v-tab>
                                    <v-tab v-if="actionName === 'updateRequest'">
                                        Komentarze
                                    </v-tab>
                                    <v-tabs-items v-model="tabs">
                                        <v-tab-item>
                                            <v-card>
                                                <v-card-text>
                                                    <Details
                                                        :request="request"
                                                        :validations="$v"
                                                        :action="actionName"
                                                        :papers="papers"
                                                        @save-material="saveMaterial"
                                                    />
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <v-card>
                                                <v-card-text>
                                                    <Attachment
                                                        :request="request"
                                                        :items="items"
                                                        :action="actionName"
                                                        @get-request="getRequest"
                                                        @update-items="updateItems"
                                                    />
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <v-card>
                                                <v-card-text>
                                                    <Enquiries
                                                        :request="request"
                                                    />
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <v-card>
                                                <v-card-text>
                                                    <Comments
                                                        :request="request"
                                                    />
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                    </v-tabs-items>
                                </v-tabs>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row v-if="actionName === 'createRequest'" align="center">
                        <v-col cols="12" sm="8" lg="4">
                            <v-btn
                                color="secondary"
                                medium
                                data-sentry-label="Dodaj materiał"
                                @click="showMaterialDialog"
                            >
                                <v-icon left>
                                    mdi-plus
                                </v-icon>
                                Dodaj materiał
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="auto">
                            <h2 class="text-h6">
                                Lista materiałów
                            </h2>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-data-table
                                    :headers="materialsHeaders"
                                    :items="requestMaterials"
                                    :mobile-breakpoint="0"
                                    name="requestMaterialsData"
                                >
                                    <template #item="{item}">
                                        <tr>
                                            <td>
                                                {{ item.materialName }}
                                            </td>
                                            <td>
                                                {{ item.materialFormat }}
                                            </td>
                                            <td>
                                                {{ item.materialWeight }}
                                            </td>
                                            <td>
                                                {{ item.unit }}
                                            </td>
                                            <td>
                                                <div class="d-inline-flex">
                                                    <v-icon
                                                        v-if="item.atStock"
                                                        small
                                                        color="success"
                                                    >
                                                        mdi-check
                                                    </v-icon>
                                                    <v-icon v-else small color="error">
                                                        mdi-close
                                                    </v-icon>
                                                </div>
                                            </td>
                                            <td>
                                                {{ parseValue(item.externalRequestNumber) }}
                                                <v-tooltip v-if="(!item.atStock && request.statusId === 40 && request.requestTypeId === 1) && (!item.externalRequestNumber && !item.externalRequestNumber && !item.deliveryDate)" :open-delay="tooltipDelay" top>
                                                    <template #activator="{on}">
                                                        <v-icon color="red" class="ml-2" v-on="on">
                                                            mdi-alert-circle
                                                        </v-icon>
                                                    </template>
                                                    <span>Brak w magazynie, uzupełnij numer zlecenia.</span>
                                                </v-tooltip>
                                            </td>
                                            <td>
                                                {{ parseValue(item.providerName) }}
                                                <v-tooltip v-if="(!item.atStock && request.statusId === 40 && request.requestTypeId === 1) && (!item.externalRequestNumber && !item.externalRequestNumber && !item.deliveryDate)" :open-delay="tooltipDelay" top>
                                                    <template #activator="{on}">
                                                        <v-icon color="red" class="ml-2" v-on="on">
                                                            mdi-alert-circle
                                                        </v-icon>
                                                    </template>
                                                    <span>Brak w magazynie, uzupełnij dostawcę.</span>
                                                </v-tooltip>
                                            </td>
                                            <td>
                                                {{ parseDateValue(item.deliveryDate) }}
                                                <v-tooltip v-if="(!item.atStock && request.statusId === 40 && request.requestTypeId === 1) && (!item.externalRequestNumber && !item.externalRequestNumber && !item.deliveryDate)" :open-delay="tooltipDelay" top>
                                                    <template #activator="{on}">
                                                        <v-icon color="red" class="ml-2" v-on="on">
                                                            mdi-alert-circle
                                                        </v-icon>
                                                    </template>
                                                    <span>Brak w magazynie, uzupełnij datę dostawy.</span>
                                                </v-tooltip>
                                            </td>
                                            <td>
                                                <div class="d-inline-flex">
                                                    <v-tooltip :open-delay="tooltipDelay" top>
                                                        <template #activator="{on}">
                                                            <v-btn
                                                                icon
                                                                data-sentry-label="Edytuj"
                                                                :disabled="!isAssigned && actionName !== 'createRequest'"
                                                                v-on="on"
                                                                @click="showEditMaterialDialog(item)"
                                                            >
                                                                <v-icon color="teal">
                                                                    mdi-pencil
                                                                </v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Edytuj</span>
                                                    </v-tooltip>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                v-if="canEditRequest || actionName === 'createRequest'"
                                color="success"
                                :disabled="!isAssigned && actionName !== 'createRequest' || requestMaterials.length === 0"
                                medium
                                class="mr-3"
                                data-sentry-label="Zapisz"
                                :loading="requestLoading"
                                @click="saveRequest"
                            >
                                Zapisz
                            </v-btn>
                            <v-btn
                                v-if="canEditRequest && actionName === 'updateRequest'"
                                color="primary"
                                medium
                                data-sentry-label="Przypisz do mnie"
                                :loading="requestLoading"
                                :disabled="isAssigned"
                                @click="showConfirmAssignUserDialog"
                            >
                                Przypisz do mnie
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/./store'
import tooltipDelay from '@/mixins/tooltip'
import PageTitle from '@/components/common/PageTitle'
import Details from './Details'
import Enquiries from './Enquiries'
import Comments from './Comments'
import Attachment from './Attachment'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import AddMaterialDialog from './AddMaterialDialog'
import { hasUserPermission } from '@/utils/permissionsHandler'
import { errorHandler } from '@/utils/errorHandler'
import dateFormatter from '@/mixins/dateFormatter'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'Request',
    components: {
        PageTitle, Details, Enquiries, Comments, Attachment, ConfirmDialog, AddMaterialDialog
    },
    mixins: [
        tooltipDelay,
        dateFormatter
    ],
    beforeRouteEnter(to, from, next) {
        //Edycja zapotrzebowania
        if (typeof to.params.id !== 'undefined') {
            store.dispatch('purchases/getRequest', to.params.id)
                .then(response => {
                    Promise.all([
                        store.dispatch('purchases/getRequestTypes'),
                        store.dispatch('purchases/getRequestStatuses'),
                        store.dispatch('configurations/getPapers'),
                        store.dispatch('configurations/getMaterials'),
                        store.dispatch('configurations/getUnitsOfMeasure')
                    ])
                        .then((responses) => {
                            next(vm => {
                                vm.actionName = 'updateRequest'
                                vm.request = Object.assign({}, response.data)
                                vm.papers = JSON.parse(JSON.stringify(responses[2].data.results))
                                vm.materials = JSON.parse(JSON.stringify(responses[3].data.results))
                                vm.pageTitle = `Zapotrzebowanie / Edycja zapotrzebowania / ${vm.request.id}`
                            })
                        })
                        .catch(error => {
                            next(error)
                            errorHandler(error)
                        })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        // Tworzenie zapotrzebowania
        } else {
            store.dispatch('purchases/clearRequestAttachments')
            Promise.all([
                store.dispatch('purchases/getRequestTypes'),
                store.dispatch('purchases/getRequestStatuses'),
                store.dispatch('configurations/getPapers'),
                store.dispatch('configurations/getMaterials'),
                store.dispatch('configurations/getUnitsOfMeasure')
            ])
                .then((responses) => {
                    next(vm => {
                        vm.papers = JSON.parse(JSON.stringify(responses[2].data.results))
                        vm.materials = JSON.parse(JSON.stringify(responses[3].data.results))
                        vm.actionName = 'createRequest'
                        vm.pageTitle = to.meta.title
                    })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('purchases/clearMaterials')
        next()
    },
    data() {
        return {
            pageTitle: '',
            requestLoading: false,
            tabs: null,
            request: {
                requestTypeId: null,
                title: null,
                content: null,
                materials: [],
                materialWeight: 1000,
                attachment: [],
                assignedTo: null,
                assignedToId: null,

            },
            actionName: null,
            items: this.value ? this.value.slice() : [],
            papers: [],
            materials: [],
            material: {
                id: null,
                materialName: null,
                materialFormat: null,
                materialWeight: 1000,
                unit: null,
                externalRequestNumber: null,
                providerName: null,
                deliveryDate: null,
                atStock: false
            },
            assignUserDialog: false,
            actionLoading: {
                assignUser: false
            },
            addMaterialDialog: false,
            action: null,
            materialsHeaders: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false,
                },
                {
                    text: 'Format materiału',
                    value: 'materialFormat',
                    sortable: false,
                },
                {
                    text: 'Ilość materiału',
                    value: 'materialWeight',
                    sortable: false,
                },
                {
                    text: 'Jednostka',
                    value: 'unit',
                    sortable: false,
                },
                {
                    text: 'W magazynie',
                    value: 'atStock',
                    sortable: false,
                },
                {
                    text: 'Numer zlecenia',
                    value: 'externalRequestNumber',
                    sortable: false,
                },
                {
                    text: 'Nazwa dostawcy',
                    value: 'providerName',
                    sortable: false,
                },
                {
                    text: 'Data dostawy',
                    value: 'deliveryDate',
                    sortable: false,
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ],
        }
    },
    computed: {
        isAssigned() {
            if (this.request.assignedToId === this.$store.state.user.userId) {
                return true
            }

            return false
        },
        userId() {
            return this.$store.state.user.userId
        },
        canEditRequest() {
            return hasUserPermission('requests_update')
        },
        requestMaterials() {
            return this.$store.state.purchases.requests.materials
        },
    },
    validations() {
        return {
            request: {
                requestTypeId: {
                    required
                },
                title: {
                    required
                },
                content: {
                    required
                },
                material: {
                    required,
                    $each: {
                        externalRequestNumber: {
                            isValid: (value, material) => {
                                return this.actionName === 'createRequest' || (material.providerName && material.externalRequestNumber && material.deliveryDate) || material.atStock || this.request.statusId !== 40 || this.request.requestTypeId !== 1 //40-closed, 1-order
                            }
                        },
                        providerName: {
                            isValid: (value, material) => {
                                return this.actionName === 'createRequest' || (material.externalRequestNumber && material.providerName && material.deliveryDate) || material.atStock || this.request.statusId !== 40 || this.request.requestTypeId !== 1//40-closed, 1-order
                            }
                        },
                        deliveryDate: {
                            isValid: (value, material) => {
                                return this.actionName === 'createRequest' || (material.externalRequestNumber && material.providerName && material.deliveryDate) || material.atStock || this.request.statusId !== 40 || this.request.requestTypeId !== 1//40-closed, 1-order
                            }
                        }
                    }
                }
            }
        }
    },
    methods: {
        updateMaterialName(material) {
            this.material.materialName = material.name
        },
        showMaterialDialog() {
            this.action = 'createMaterial'
            this.material.id = this.requestMaterials.length + 1,
            this.material.materialName = null,
            this.material.materialFormat = null,
            this.material.materialWeight = 1000,
            this.material.unit = null,
            this.material.externalRequestNumber = null,
            this.material.providerName = null,
            this.material.deliveryDate = null,
            this.material.atStock = false
            this.addMaterialDialog = true
        },
        showEditMaterialDialog(item) {
            this.action = 'updateMaterial'
            let material = Object.assign({}, item)

            this.material = material
            this.material.deliveryDate ? this.material.deliveryDate = this.material.deliveryDate.substring(0, 10) : null
            this.$refs.addMaterialDialog.updateRadioGroup(item)
            this.addMaterialDialog = true
        },
        closeMaterialDialog() {
            this.addMaterialDialog = false
            setTimeout(() => {
                this.material.materialName = null
            }, 500)
        },
        updateItems(items) {
            this.items = items
        },
        getRequest(requestId) {
            this.$store.dispatch('purchases/getRequest', requestId)
                .then(response => {
                    this.request = response.data
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showConfirmAssignUserDialog() {
            this.assignUserDialog = true
        },
        closeConfirmAssignUserDialog() {
            this.assignUserDialog = false
        },
        assignCurrentUser() {
            this.actionLoading.assignUser = true

            const payload = {
                id: this.request.id,
                assignedToId: this.userId
            }

            this.$store.dispatch('purchases/updateRequest', payload)
                .then((response) => {
                    this.getRequest(response.data.id)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.assignUser = false
                    this.closeConfirmAssignUserDialog()
                })
        },
        saveMaterial() {
            if (this.action === 'updateMaterial') {
                this.request.materials.forEach(function(item) {
                    if (item.id === this.material.id) {
                        item = this.material
                    }
                })
            } else {
                this.request.materials.push(this.material)
            }

        },
        parseValue(value) {
            return !value ? '-' : value
        },
        parseDateValue(value) {
            return !value ? '-' : this.formatDate(value).substring(0, 10)
        },
        saveRequest() {
            this.request.material = this.requestMaterials
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })
            } else {
                this.requestLoading = true
                if (this.actionName == 'createRequest') {
                    this.requestMaterials.forEach(item => delete item.id)
                    this.$store.dispatch('purchases/createRequest', {
                        requestTypeId: this.request.requestTypeId,
                        title: this.request.title,
                        content: this.request.content,
                        materials: this.requestMaterials
                    })
                        .then((response) => {
                            if (this.items.length > 0) {
                                const formData = new FormData()

                                this.items.forEach(item => {
                                    formData.append('file', item)
                                })

                                formData.append('requestId', response.data.id)

                                this.$store.dispatch('purchases/createRequestAttachment', formData)
                                    .catch(error => {
                                        errorHandler(error)
                                    })
                            }
                        })
                        .catch(error => {
                            errorHandler(error)
                        })
                        .finally(() => {
                            this.close()
                        })
                }
                if (this.actionName == 'updateRequest') {
                    this.$store.dispatch('purchases/updateRequest', {
                        id: this.request.id,
                        requestTypeId: this.request.requestTypeId,
                        content: this.request.content,
                        assignedTo: this.request.assignedTo,
                        statusId: this.request.statusId,
                        materials: this.request.materials
                    })
                        .then((response) => {
                            if (this.items.length > 0) {
                                const formData = new FormData()

                                this.items.forEach(item => {
                                    formData.append('file', item)
                                })

                                formData.append('requestId', response.data.id)

                                this.$store.dispatch('purchases/createRequestAttachment', formData)
                                    .catch(error => {
                                        errorHandler(error)
                                    })
                            }
                        })
                        .catch(error => {
                            errorHandler(error)
                        })
                        .finally(() => {
                            this.close()
                        })
                }
            }
        },
        close() {
            this.requestLoading = false
            this.$router.push({ name: 'purchasesRequests' })
                .catch(error => {
                    errorHandler(error)
                })
            this.$v.$reset()
        },
    }

}
</script>

